import { connect } from 'react-redux';
import selector from '../../store/models/connectionStatus';

export default connect(selector);



// WEBPACK FOOTER //
// ./src/components/ConnectionStatus/connect.js